import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";

import { IPropsFC, ISelectItems } from "interfaces/intarfaces";

import { IInputHookOut, InputLabel } from "components/Input";
import { ICalendar } from "components/Calendar";
import { DateRange } from "components/InputCalendar";
import Select, { ISelectHook } from "components/Select";
import { Container } from "./styles";

import { getCities, getCountries, getProvince } from "utils/fetchMapInfo";
import { useContextHospi } from "context/ContextHospi";
import SearchSelect, { ISearchSelect } from "components/SearchSelect";

import { TLang } from "assets/data/isoNameLanguage";

interface ISearchCriteria {
  dateIn: ICalendar;
  dateOut: ICalendar;
  budget: IInputHookOut;
  countryResidence: ISelectHook;
  provinceResidence: ISelectHook;
  cityResidence: ISelectHook;
}

export const SearchCriteria: React.FC<ISearchCriteria> = ({
  dateIn,
  dateOut,
  budget,
  countryResidence,
  provinceResidence,
  cityResidence,
}) => {
  const { userStatus } = useContextHospi();
  const user = userStatus === "host" ? "host" : "student";
  const { t, i18n } = useTranslation(user);
  const currLang = i18n.language.toUpperCase() as TLang;
  const [cities, setCities] = useState<ISelectItems[]>(
    getCities(
      provinceResidence.value as string,
      countryResidence.value as string,
      currLang
    )
  );

  useEffect(() => {
    setCities(
      getCities(
        undefined,
        countryResidence.value ? (countryResidence.value as string) : undefined,
        currLang
      )
    );
  }, [countryResidence.value]);

  useEffect(() => {
    if (cityResidence.value) {
      const province: string = getProvince(cityResidence.value as string);
      !!province.length && provinceResidence.changeItem(province);
    }
    // eslint-disable-next-line
  }, [cityResidence.value]);

  const titlePholder = (variable: string): IPropsFC => {
    return {
      title: t(`studentProfile.searchCriteria.form.${variable}.title`),
      placeholder: t(
        `studentProfile.searchCriteria.form.${variable}.placeholder`
      ),
      w: "initial",
      grow: "1",
    };
  };

  return (
    <Container >
      <DateRange
        rightBorder={dateOut.value}
        {...dateIn}
        title={t(`studentProfile.searchCriteria.form.moveInDate.title`)}
        id="dateIn"
        isClose
      />
      <DateRange
        leftBorder={dateIn.value}
        {...dateOut}
        title={t(`studentProfile.searchCriteria.form.moveOutDate.title`)}
        id="dateOut"
        isClose
      />
      <InputLabel
        {...budget}
        prefix="€"
        type="number"
        {...titlePholder("budget")}
        id="budget"
      />
      <Select

        {...countryResidence}
        {...titlePholder("country")}
        items={getCountries(currLang)}
        id="countryWillGo"
        disabled
      />
      <SearchSelect
        {...cityResidence}
        {...titlePholder("city")}
        id="cityWillGo"
        items={cities}
      />
    </Container>
  );
};
